export const socket = new WebSocket(
  `${process.env.REACT_APP_WEBSOCKET_BASE_URL}/cable`
);
